import angular from "angular";

angular
	.module('app')
	.component('finApplicationReplyForm', {
		template: require('./fin-application-reply-form.html'),
        controller: ['$http', controller],
        bindings: {
		    application: '<',
        }
    });
    
function controller($http) {
 
	let $ctrl = this;
	
	$ctrl.$onInit = function () {
		$ctrl.loading = false;
    };

	$ctrl.showAppCar = function (carIndex) {
		$ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
	}

	$ctrl.submit = function (button) {
		$ctrl.loading = true;
		$http.post('/fin/applications/' + $ctrl.application.id, {
			button: button,
			comment: $ctrl.comment,
		}).then(function (response){
			$ctrl.loading = false;
			window.Swal.fire({
				icon: 'success',
				title: response.data.message,
			}).then(function () {
				window.location = '/';
			})
		}, function (error) {
			$ctrl.loading = false;
			let checked = false;
			let message = '';
			angular.forEach(error.data.errors, function (value, key){
				if (!checked) {
					message += value[0];
					checked = true;
				}
			});
			if (message.length) {
				window.Swal.fire({
					icon: 'error',
					title: message,
				})
			} else {
				alert("Не известная ошибка обратитесь к администраций сайта");
			}
		})
	}
}